export { PhilosophyPage as default } from '@/components/enpages/Company/Philosophy'
